module.exports = __webpack_public_path__ + "static/media/store-large.6296e7b4.webp";